/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'pki-certificate-authority-modal';
const prefix = `${moduleName}.${componentName}`;

export const generalHeader = `${prefix}.generalHeader`;
export const modalTitleAddCa = `${prefix}.modalTitleAddCa`;
export const uploadCaFileInputLabel = `${prefix}.uploadCaFileInputLabel`;

export const ENGLISH = {
    [generalHeader]: 'General',
    [modalTitleAddCa]: 'Add CA',
    [uploadCaFileInputLabel]: 'Upload Certificate Authority File (CA)',
};
